import { createActionGroup, props } from '@ngrx/store';
import {
  CreateMcpAccessGrantPayload,
  McpAccessGrant,
  McpAccessInvitationOutcome,
  McpAccessListQuery,
  McpAccessListResult,
  McpAccessMutationResult,
  RevokeMcpAccessGrantPayload,
  UpdateMcpAccessTenantsPayload,
} from '@niko-crm/ui';

export const McpAccessActions = createActionGroup({
  source: 'admin-McpAccess',
  events: {
    'Load Grants': props<{ query: McpAccessListQuery }>(),
    'Load Grants Success': props<{ result: McpAccessListResult }>(),
    'Load Grants Failure': props<{ error: string }>(),

    'Create Grant': props<{ payload: CreateMcpAccessGrantPayload }>(),
    'Create Grant Success': props<{ grant: McpAccessMutationResult }>(),
    'Create Grant Failure': props<{ error: string }>(),

    'Update Tenants': props<{ id: string; payload: UpdateMcpAccessTenantsPayload }>(),
    'Update Tenants Success': props<{ grant: McpAccessGrant }>(),
    'Update Tenants Failure': props<{ error: string }>(),

    'Revoke Grant': props<{ id: string; payload: RevokeMcpAccessGrantPayload }>(),
    'Revoke Grant Success': props<{ grant: McpAccessGrant }>(),
    'Revoke Grant Failure': props<{ error: string }>(),

    'Reactivate Grant': props<{ id: string }>(),
    'Reactivate Grant Success': props<{ grant: McpAccessGrant }>(),
    'Reactivate Grant Failure': props<{ error: string }>(),

    'Resend Invitation': props<{ id: string }>(),
    'Resend Invitation Success': props<{ grant: McpAccessMutationResult }>(),
    'Resend Invitation Failure': props<{ error: string }>(),

    'Resync Grant': props<{ id: string }>(),
    'Resync Grant Success': props<{ grant: McpAccessMutationResult }>(),
    'Resync Grant Failure': props<{ error: string }>(),

    'Get Invitation Link': props<{ id: string }>(),
    'Get Invitation Link Success': props<{ id: string; invitation: McpAccessInvitationOutcome }>(),
    'Get Invitation Link Failure': props<{ error: string }>(),
  },
});
